import PropTypes from 'prop-types';

import ButtonClean from '~/components/ButtonClean';

import styles from './ActionButton.module.scss';

function ActionButtonItem({ children, onClick, title }) {
  return (
    <ButtonClean
      className={styles.actionButtonItem}
      onClick={onClick}
    >
      {title && <p>{title}</p>}
      {children}
    </ButtonClean>
  );
}

ActionButtonItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  onClick: PropTypes.func,
  title: PropTypes.string,
};

export default ActionButtonItem;
